export class ProcessingStatus {

  key: string;
  dictionaryKey: string;

}
